if (!customElements.get('ofp-moments')) {
  customElements.define('ofp-moments', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.track = this.querySelector('.ofp-moments__track');
      this.cards = Array.from(this.querySelectorAll('[data-moment]'));
      this.controls = this.querySelector('[data-moment-controls]');
      this.previous = this.querySelector('[data-moment-previous]');
      this.next = this.querySelector('[data-moment-next]');
      this.count = this.querySelector('[data-moment-count]');
      this.mobile = matchMedia('(max-width: 989px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.previous.addEventListener('click', () => this.go(this.index - 1), { signal });
      this.next.addEventListener('click', () => this.go(this.index + 1), { signal });
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.update(), 100);
      }, { passive: true, signal });
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches) return;
        const indices = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.cards.length - 1 };
        if (!(event.key in indices)) return;
        event.preventDefault();
        this.go(indices[event.key]);
      }, { signal });
      this.mobile.addEventListener('change', () => {
        this.track.scrollLeft = 0;
        this.update();
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const index = this.cards.findIndex(card => card.dataset.blockId === event.detail?.blockId);
        if (index >= 0 && this.mobile.matches) this.go(index);
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }
    go(index) {
      const target = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!target || !this.mobile.matches) return;
      this.track.scrollTo({ left: target.offsetLeft, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
    }
    update() {
      if (!this.cards.length) return;
      this.index = this.mobile.matches ? this.cards.reduce((best, card, index) =>
        Math.abs(card.offsetLeft - this.track.scrollLeft) < Math.abs(this.cards[best].offsetLeft - this.track.scrollLeft) ? index : best, 0) : 0;
      this.controls.hidden = !this.mobile.matches || this.cards.length < 2;
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.cards.length - 1;
      this.count.textContent = `${this.index + 1} / ${this.cards.length}`;
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      this.resizeObserver?.disconnect();
      clearTimeout(this.scrollTimer);
    }
  });
}
